import React, { memo } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import useQuotationProduct from 'src/hooks/quotation-v2/use-quotation-products';

const useStyles = makeStyles(() => ({
  span: {
    fontWeight: 'bolder'
  }
}));

interface QuotationSubheaderProps {
  customerName?: string;
  branchName?: string;
}

const Component = ({ customerName, branchName }: QuotationSubheaderProps) => {
  const classes = useStyles();
  const { templateDetails } = useQuotationProduct();

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: '1em',
        paddingBottom: '1em'
      }}
    >
      <Typography>
        <span className={classes.span}>To: </span>{' '}
        {templateDetails?.raw_name || customerName}
      </Typography>
      <Typography>
        <span className={classes.span}>Branch: </span> {branchName}
      </Typography>
    </Box>
  );
};
export const QuotationSubheader = memo(Component);
